import axios from 'axios';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {},

  mutations: {},

  actions: {
    // eslint-disable-next-line
    async changePassword({ commit }, obj) {
      await axios.put(
        `${url}/user/${obj.userId}`,
        { ...obj.data },
        { headers: { 'x-access-token': obj.token } },
      );
    },
  },

  getters: {},
};
